import assert from 'assert';
import {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useHistory} from 'react-router-dom';
import * as store from '@/store';
import sdk from '@/sdk';
import toast, {ToastType} from '@/components/Toast';
import {DocumentOperateType, PathParams, WizDocumentCreateDoc} from '@/interface';
import {BOOK_TYPE, BookType} from '@/constants/document/doc';
import routers, {buildPath} from '@/config/routers';
import {isPersonalMyself} from '@/domains/space/Repository/knowledgeUtils';
import {clickNewBuildPage, createBook, feLogger} from '@/buried';
import styles from './index.module.scss';


interface CreateDirectoryProps {
    createDirectory?: {
        parentGuid: string | null;
        feLogNumber: string;
        openInNewTab?: boolean;
        createPersonPage?: boolean;
        inherit?: number;
        scope?: number;
    };
    curDocument?: WizDocument;
}

function CreateDirectory(props: CreateDirectoryProps) {
    const intl = useIntl();
    const history = useHistory();
    const {
        createDirectory, curDocument,
    } = props;
    useEffect(() => {
        async function createDir(
            parentGuid: string, logNumber: string, openInNewTab?: boolean, createPersonPage?: boolean, inherit?: number,
            scope?: number) {
            try {
                let repository = store.getCurRepository();
                if (createPersonPage) {
                    repository = sdk.as.userRepository as any;
                }
                assert(repository);
                const {spaceGuid, groupGuid, repositoryGuid} = repository;
                const ksServer = await sdk.getKsServer(repository);
                const date = new Date();
                const doc = {
                    position: date.valueOf(),
                    name: intl.formatMessage({id: 'defaultDirectoryTitle'}),
                    parentGuid: parentGuid,
                    spaceGuid: spaceGuid,
                    groupGuid: groupGuid,
                    repositoryGuid: repositoryGuid,
                    bookType: BOOK_TYPE.IS_BOOK,
                    inherit: inherit,
                    scope: scope,
                };
                const result = await ksServer.createDocumentDirectory(doc as WizDocumentCreateDoc);
                const userGuid = sdk.as.user?.userGuid;
                assert(userGuid);
                feLogger(createBook(
                    {
                        'pageid': result?.docGuid,
                        'position': logNumber,
                        'userid': userGuid,
                        'isCreate': '0',
                    }
                ));
                const params: PathParams = {
                    spaceGuid: result.spaceGuid,
                    groupGuid: result.groupGuid,
                    repositoryGuid: result.repositoryGuid,
                    docGuid: result.docGuid,
                };
                const url = buildPath(routers.Knowledge.path, params);
                store.setDocumentOperate({
                    docList: [result],
                    type: DocumentOperateType.Create,
                    data: {
                        url,
                        openInNewTab: !!openInNewTab,
                        type: 2,
                    },
                });
                if (openInNewTab) {
                    window.open(`${url}?isNewDoc=true`);
                }
            } catch (err) {
                console.error(err);
                toast({
                    content: intl.formatMessage({id: 'errorCreateDoc'}),
                    type: ToastType.Error,
                });
                feLogger(createBook(
                    {
                        'pageid': '',
                        'position': logNumber,
                        'userid': sdk.as.user?.userGuid || '',
                        'isCreate': '1',
                    }
                ));
            }
        }
        if (createDirectory && createDirectory.parentGuid !== null) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            createDir(
                createDirectory.parentGuid,
                createDirectory.feLogNumber,
                createDirectory?.openInNewTab,
                createDirectory?.createPersonPage,
                createDirectory?.inherit,
                createDirectory?.scope
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createDirectory]);


    return (
        <div className={styles.root} />
    );
}

const CreateDirectoryImpl = store.connect([
    store.KEYS.CREATE_DIRECTORY,
])(CreateDirectory);

export default CreateDirectoryImpl;
